<template>
    <v-menu v-model="display"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    v-bind="textFieldProps"
                    :disabled="disabled"
                    :loading="loading"
                    :label="label"
                    :value="selectedDatetimeDisplay"
                    v-on="on"
                    readonly
                    :error-messages="errorMessages"
            >
                <template v-slot:progress>
                    <slot name="progress">
                        <v-progress-linear color="primary" indeterminate absolute height="2"></v-progress-linear>
                    </slot>
                </template>
            </v-text-field>
        </template>

        <v-card>
            <v-card-text class="px-0 py-0">
                <v-tabs fixed-tabs v-model="activeTab">
                    <v-tab key="calendar">
                        <slot name="dateIcon">
                            <v-icon>event</v-icon>
                        </slot>
                    </v-tab>
                    <v-tab key="timer" :disabled="dateSelected">
                        <slot name="timeIcon">
                            <v-icon>access_time</v-icon>
                        </slot>
                    </v-tab>
                    <v-tab-item key="calendar">
                        <v-date-picker v-model="date" v-bind="datePickerProps" @input="showTimePicker" full-width
                                       :locale="locale"></v-date-picker>
                    </v-tab-item>
                    <v-tab-item key="timer">
                        <v-time-picker :locale="locale"
                                       ref="timer"
                                       class="v-time-picker-custom"
                                       v-model="time"
                                       v-bind="timePickerProps"
                                       full-width
                        ></v-time-picker>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <slot name="actions" :parent="this">
                    <v-btn color="grey lighten-1" dark text @click.native="clearHandler">{{$t("lang.common.clear")}}
                    </v-btn>
                    <v-btn dark class="yoprimary" text @click="okHandler">{{$t("lang.common.save")}}</v-btn>
                </slot>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
    import {format, parse} from 'date-fns'
    import moment from 'moment'

    const DEFAULT_DATE = ''
    const DEFAULT_TIME = '00:00:00'
    const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'
    const DEFAULT_TIME_FORMAT = 'HH:mm:ss'
    const DEFAULT_DIALOG_WIDTH = 150
    const DEFAULT_CLEAR_TEXT = 'CLEAR'
    const DEFAULT_OK_TEXT = 'OK'

    export default {
        name: 'v-datetime-picker',
        model: {
            prop: 'datetime',
            event: 'input'
        },
        props: {
            datetime: {
                type: [Date, String],
                default: null
            },
            disabled: {
                type: Boolean
            },
            loading: {
                type: Boolean
            },
            label: {
                type: String,
                default: ''
            },
            dialogWidth: {
                type: Number,
                default: DEFAULT_DIALOG_WIDTH
            },
            dateFormat: {
                type: String,
                default: DEFAULT_DATE_FORMAT
            },
            timeFormat: {
                type: String,
                default: 'HH:mm'
            },
            clearText: {
                type: String,
                default: DEFAULT_CLEAR_TEXT
            },
            okText: {
                type: String,
                default: DEFAULT_OK_TEXT
            },
            textFieldProps: {
                type: Object
            },
            datePickerProps: {
                type: Object
            },
            timePickerProps: {
                type: Object
            },
            errorMessages: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                display: false,
                activeTab: 0,
                date: DEFAULT_DATE,
                time: DEFAULT_TIME
            }
        },
        mounted() {
            this.init()
        },
        computed: {
            dateTimeFormat() {
                return this.dateFormat + ' ' + this.timeFormat
            },
            defaultDateTimeFormat() {
                return DEFAULT_DATE_FORMAT + ' ' + DEFAULT_TIME_FORMAT
            },
            formattedDatetime() {
                return this.selectedDatetime ? format(this.selectedDatetime, this.dateTimeFormat) : ''
            },
            selectedDatetime() {
                if (this.date && this.time) {
                    let datetimeString = this.date + 'T' + this.time;
                    console.log(this.date);
                    console.log(this.time);
                    if (this.time.length === 5) {
                        datetimeString += ':00'
                    }
                    let tz = new Date().getTimezoneOffset();
                    let sign = "-";
                    if(tz <0){
                        sign = "+";
                        tz = -1 * tz;
                    }
                    let hhz = tz / 60;
                    if(hhz <10){
                        hhz = "0"+hhz;
                    }
                    let mmz = tz % 60;
                    if(mmz < 10){
                        mmz = "0" + mmz;
                    }
                    return datetimeString+sign + hhz+":"+mmz;
                    //return parse(datetimeString, this.defaultDateTimeFormat, new Date())
                } else {
                    return null
                }
            },

            selectedDatetimeDisplay() {
                if (this.date && this.time) {
                    let datetimeString = this.date + ' ' + this.time;
                    console.log(this.date);
                    console.log(this.time);
                    if (this.time.length === 5) {
                        datetimeString += ':00'
                    }
                    let dd = parse(datetimeString, this.defaultDateTimeFormat, new Date());
                    console.log(dd);
                    let str = moment(dd).format("DD/MM/YYYY HH:mm:ss");
                    console.log(str);
                    return str;
                    //return parse(datetimeString, this.defaultDateTimeFormat, new Date())
                } else {
                    return null
                }
            },
            dateSelected() {
                return !this.date
            },
            locale: function () {
                return this.$i18n.locale;
            }
        },
        methods: {
            init() {
                if (!this.datetime) {
                    return
                }

                let initDateTime
                if (this.datetime instanceof Date) {
                    initDateTime = this.datetime
                } else if (typeof this.datetime === 'string' || this.datetime instanceof String) {
                    // see https://stackoverflow.com/a/9436948
                    initDateTime = parse(this.datetime, this.dateTimeFormat, new Date())
                }

                this.date = format(initDateTime, DEFAULT_DATE_FORMAT)
                this.time = format(initDateTime, DEFAULT_TIME_FORMAT)
            },
            okHandler() {
                this.resetPicker()
                console.log(this.selectedDatetime);
                this.$emit('input', this.selectedDatetime)
            },
            clearHandler() {
                this.resetPicker()
                this.date = DEFAULT_DATE
                this.time = DEFAULT_TIME
                this.$emit('input', null)
            },
            resetPicker() {
                this.display = false
                this.activeTab = 0
                if (this.$refs.timer) {
                    this.$refs.timer.selectingHour = true
                }
            },
            showTimePicker() {
                this.activeTab = 1
            }
        },
        watch: {
            datetime: function () {
                this.init()
            }
        }
    }
</script>
